<!--

    寄卖 Consignment.vue

-->
<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-row type="flex" class="row-bg" justify="space-around" style="padding-top:50px">
        <!--主要寄卖表单-->
        <el-col :span="16">
          <!--寄卖须知 start-->
          <el-collapse v-model="寄卖须知折叠状态">
            <el-collapse-item title="寄卖须知" name="寄卖须知">
              <p v-html="寄卖须知" style="font-size:130%"></p>
              <p class="my-middle">
                <el-button plain v-on:click="agree()">我已阅读并同意</el-button>
              </p>
            </el-collapse-item>
          </el-collapse>
          <el-row type="flex" class="row-bg" justify="space-around" style="padding-top:50px">
            <el-col :span="24">
              <!--
                  表單
              -->
              <h3>寄卖</h3>
              <el-row>
                <div class="my-middle">
                  <p>
                    <el-button
                      @click="selectConsignmentItem('同人周边')"
                      :icon="寄卖同人收藏本icon"
                      type="primary"
                      style="width: 120px; height: 40px; text-align: center; font-size: 14px; padding: 0;"
                    >同人收藏本</el-button>
                    <el-button
                      @click="selectConsignmentItem('同人收藏本')"
                      :icon="寄卖同人周边icon"
                      type="primary"
                      style="width: 120px; height: 40px; text-align: center; font-size: 14px; padding: 0;"
                    >同人周边</el-button>
                  </p>
                  <el-alert
                    v-html="sellinginfo"
                    type="info"
                    show-icon
                    class="el-alert__title"
                    style="padding: 8px 16px; margin: 20px 0 20px 0;"
                  ></el-alert>
                </div>
              </el-row>
              <el-form>
                <el-form-item label="寄卖人:">
                  <el-input v-model="consignmentFormData['寄卖人OR社团微博']" placeholder="寄卖人OR社团微博"></el-input>
                </el-form-item>
                <el-form-item label="支付宝账户:">
                  <el-input v-model="consignmentFormData['支付宝账户']" placeholder="支付宝账户"></el-input>
                </el-form-item>
                <el-form-item label="支付宝验证姓名:">
                  <el-input v-model="consignmentFormData['支付宝验证姓名']" placeholder="支付宝验证姓名"></el-input>
                </el-form-item>
                <el-form-item label="支付宝使用人关系:">
                  <el-input v-model="consignmentFormData['支付宝使用人关系']" placeholder="支付宝使用人关系"></el-input>
                </el-form-item>
                <el-form-item label="是否需要在官方微博宣传">
                  <el-radio-group v-model="consignmentFormData['是否需要在官方微博宣传']">
                    <el-radio-button label="是">是</el-radio-button>
                    <el-radio-button label="否">否</el-radio-button>
                  </el-radio-group>
                </el-form-item>

                <el-form-item label="是否转发抽奖">
                  <el-radio-group v-model="consignmentFormData['是否转发抽奖']">
                    <el-radio-button label="是">是</el-radio-button>
                    <el-radio-button label="否">否</el-radio-button>
                  </el-radio-group>
                  <p v-if="consignmentFormData['是否转发抽奖']=='是'">提示：奖品由寄卖方提供</p>
                </el-form-item>
                <el-collapse v-model="collapseActive1">
                  <el-collapse-item title="解决方案" name="解决方案">
                    <p v-html="瑕疵品处理方案教程" style="font-size:130%"></p>
                    <p class="my-middle">
                      <el-button plain v-on:click="AgreeBrokenItems()">我已阅读并同意瑕疵品处理方案</el-button>
                    </p>
                  </el-collapse-item>
                </el-collapse>
                <br>

                <el-form-item label="瑕疵品是否退回">
                  <el-radio-group v-model="consignmentFormData['瑕疵品是否退回']">
                    <el-radio-button label="是">是</el-radio-button>
                    <el-radio-button label="否">否</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="瑕疵品处理的其它方案">
                  <el-input type="textarea" v-model="consignmentFormData['瑕疵品处理的其它方案']"></el-input>
                </el-form-item>

                <br>
                <br>
                <br>
              </el-form>
              <h3 id="work-for-go-top">作品</h3>
              <el-form :rules="formRules" ref="consignmentFormData">
                <el-tag
                  :key="item.key"
                  class="consignment-product-tag"
                  v-for="item in $root.consignmentItems"
                >{{item.value.length > 12 ? item.value.substring(1, 12) + '...':item.value}}</el-tag>
                <el-button
                  class="consignment-product-tag"
                  type="primary"
                  size="small"
                  @click="$root.openTheSubmitForm()"
                >修改/删除</el-button>
                <el-form-item label="作品类型" label-width="80px">
                  <el-input v-model="consignmentFormData['作品类型']" placeholder="作品类型"></el-input>
                </el-form-item>
                <el-form-item label="作品名称" label-width="80px" prop="作品名称">
                  <el-input v-model="consignmentFormData['作品名称']" placeholder="作品名称"></el-input>
                </el-form-item>
                <el-form-item label="作品数量" :inline="true" label-width="80px">
                  <el-input-number
                    v-model="consignmentFormData['数量']"
                    :min="1"
                    :max="10000"
                    label="数量"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="价格" label-width="80px">
                  <el-input v-model="consignmentFormData['价格']" placeholder="人民币（CNY）"></el-input>
                </el-form-item>

                <el-form-item label="尺寸" label-width="80px">
                  <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                    <el-input v-model="consignmentFormData['尺寸长']" placeholder="尺寸长（cm）"></el-input>
                  </el-col>

                  <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                    <el-input v-model="consignmentFormData['尺寸宽']" placeholder="尺寸宽（cm）"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="是否预售" label-width="80px">
                  <el-radio-group v-model="consignmentFormData['是否预售']">
                    <el-radio-button label="是">是</el-radio-button>
                    <el-radio-button label="否">否</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="预售时间" label-width="80px">
                  <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                    <el-date-picker
                      type="datetime"
                      placeholder="开始时间"
                      v-model="consignmentFormData['预售开始时间']"
                      value-format="yyyy 年 MM 月 dd 日"
                      format="yyyy 年 MM 月 dd 日"
                      style="width: 100%;"
                    >></el-date-picker>
                  </el-col>

                  <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                    <el-date-picker
                      type="datetime"
                      placeholder="结束时间"
                      v-model="consignmentFormData['预售结束时间']"
                      value-format="yyyy 年 MM 月 dd 日"
                      format="yyyy 年 MM 月 dd 日"
                      style="width: 100%;"
                    ></el-date-picker>
                  </el-col>
                </el-form-item>
                <el-form-item label="到货时间" label-width="80px">
                  <el-date-picker
                    type="datetime"
                    placeholder="下印时间+工期+运输时间"
                    v-model="consignmentFormData['到货时间']"
                    value-format="yyyy 年 MM 月 dd 日"
                    format="yyyy 年 MM 月 dd 日"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="是否有特典">
                  <el-radio-group v-model="consignmentFormData['是否有特典']">
                    <el-radio-button label="是">是</el-radio-button>
                    <el-radio-button label="否">否</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="特典赠送规则">
                  <el-input v-model="consignmentFormData['特典赠送规则']" placeholder="特典赠送规则"></el-input>
                </el-form-item>
                <el-form-item label="特典赠送方案">
                  <el-input type="textarea" v-model="consignmentFormData['特典赠送方案']"></el-input>
                </el-form-item>
                <el-form-item label="预售其它规则">
                  <el-input type="textarea" v-model="consignmentFormData['预售其它规则']"></el-input>
                </el-form-item>
                <el-button v-on:click="addEvent('consignmentFormData')" style="margin:10px">提交</el-button>
                <el-button v-on:click="clear()" style="margin:10px">清空</el-button>
                <a href="#work-for-go-top">
                  <el-button style="margin:10px">
                    返回作品頂部
                    <i class="el-icon-upload2 el-icon--right"></i>
                  </el-button>
                </a>
              </el-form>

              <!--
                  表單結束
              -->
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </transition>
</template>
<script>
export default {
  methods: {
    agree: function() {
      this.$notify({
        title: "您已阅读并同意相关内容",
        dangerouslyUseHTMLString: true,
        message: `您提交表单或者点击该按钮均代表您已阅读并同意相关内容！<br> 快去填写相关内容吧`,
        type: "success"
      });
      this.寄卖须知折叠状态 = [];
      this.collapseActive = [];
    },
    //寄賣基礎信息
    addEvent: function() {
      if (this.consignmentFormData.作品名称 == "") {
        this.$notify.error({
          title: "失敗",
          dangerouslyUseHTMLString: true,
          message: `请填写作品名称`
        });
      } else {
        this.$root.add(this.consignmentFormData);
      }
    },
    clear: function() {
      this.consignmentFormData = {
        title: "寄卖相关",
        寄卖同人收藏本: "",
        寄卖同人周边: "",
        作品名称: ""
      };
    },

    AgreeBrokenItems: function() {
      this.$notify({
        title: "您已同意瑕疵品处理条款。",
        dangerouslyUseHTMLString: true,
        message:
          "您提交表单/点击该按钮/看到这条信息均说明您已经同意了瑕疵品处理条款。<br>现在您可以继续填写了。",
        type: "success"
      });
      this.collapseActive1 = [];
    },
    //暫時蠢一點解決
    selectConsignmentItem(itemName) {
      if (itemName == "同人周边") {
        this.寄卖产品.同人收藏本 = !this.寄卖产品.同人收藏本;
        if (this.寄卖产品.同人收藏本) {
          this.寄卖同人收藏本icon = "el-icon-success";
          this.consignmentFormData.寄卖同人收藏本 = "是";
        } else {
          this.寄卖同人收藏本icon = "el-icon-error";
          this.consignmentFormData.寄卖同人收藏本 = "否";
        }
      } else if (itemName == "同人收藏本") {
        this.寄卖产品.同人周边 = !this.寄卖产品.同人周边;
        if (this.寄卖产品.同人周边) {
          this.寄卖同人周边icon = "el-icon-success";
          this.consignmentFormData.寄卖同人周边 = "是";
        } else {
          this.寄卖同人周边icon = "el-icon-error";
          this.consignmentFormData.寄卖同人周边 = "否";
        }
      } else {
        null;
      }
    }
  },
  data() {
    return {
      formRules: {
        作品名称: [
          { required: true, message: "请输入作品名称", trigger: "change" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ]
      },
      寄卖须知折叠状态:
        (document.documentElement.clientWidth || document.body.clientWidth) >
        800
          ? ["寄卖须知"]
          : [],
      forcollapse: ["allsame"],
      //寄卖数据
      collapseActive: ["寄卖须知"],
      collapseActive1: ["解决方案"],
      寄卖产品: {
        同人收藏本: false,
        同人周边: false
      },
      寄卖同人周边icon: "el-icon-error",
      寄卖同人收藏本icon: "el-icon-error",
      consignmentFormData: {
        title: "寄卖相关",
        寄卖同人收藏本: "否",
        寄卖同人周边: "否",
        作品名称: ""
      },
      labelPosition: "left",
      sellinginfo: `同人收藏本:寄卖费-8%
同人周边:寄卖费-10%
同人收藏本+周边:寄卖费-8%
`,
      寄卖须知: `

<p>1.为保证寄卖作品的存储和销售的便利性，委托寄卖的作品请尽量自带独立pp袋包装，且每套同类别作品包在同一包装内（例寄卖作品为本子+随本附赠的赠品，则本子和赠品包装在同一个包装内）。如果没有包装或寄卖同时委托我方进行包装服务，将收取包装费，包装费视作品的具体情况而定，包装费标准每份寄卖作品/0.3-0.8元 
</p>
<p>2. 寄卖作品的预售时间从上架到预售结束最长1个月，预售结束后如需继续寄卖服务则在预售寄卖作品发货结束后变为现货再次上架。现货寄卖服务的服务时间最长6个月，寄卖时间截止后将联系作者将作品寄回作者处。 
</p>
<p>3. 发货开始后每月30日-次月2日由客服联系作者进行结算，结算范围为已确认收货的寄卖作品订单。第一次结算周期为从产品发货日至当月25日（如25日之前无确认收货订单则转入下月结算），之后结算周期为上月26日至本月25号的自然月直至结束寄卖服务，结算范围为已确认收货的寄卖作品订单。 
</p>
<p>4. 预售的寄卖作品在开始发货到结束，数量不大的情况2-3个工作日结束预售发货，如数量较多、需要包装以及特殊时间段（例如大量作品在某月集中发售），则按照寄卖服务的下单日期安排发货。 
</p>
<p>5. 预售结束后，由于需要留出买家收货后反馈作品瑕疵的时间，故无法在预售结束时直接变为现货。所有寄卖作品一般在3-7个工作日之内变为现货再次上架。 
</p>
<p>6. 漫寻谷采用分仓发货模式，预售产品统一在上海仓库发货，如需要继续以现货的形式寄卖则在哈尔滨仓库进行现货贩售。两个仓库间的调拨费用由漫寻谷承担，委托人需承担作品寄卖至上海仓库的邮费以及寄卖结束之后的寄回邮费。 
</p>
<p>7. 寄卖需准备至少一张预览图（800*800,72dpi，500k以下）和至少一张宣图（750宽，72dpi，3M以下），方便我方进行寄卖作品在各平台进行宣传。 
</p>

<p>漫寻谷寄卖平台宣传服务</p>
<p>1.为保证寄卖作品的存储和销售的便利性，委托寄卖的作品请尽量自带独立pp袋包装，且每套同类别作品包在同一包装内（例寄卖作品为本子+随本附赠的赠品，则本子和赠品包装在同一个包装内）。如果没有包装或寄卖同时委托我方进行包装服务，将收取包装费，包装费视作品的具体情况而定，包装费标准：每份寄卖作品/0.3-0.8元 
</p>
<p>2. 寄卖作品的预售时间从上架到预售结束最长1个月，预售结束后如需继续寄卖服务则在预售寄卖作品发货结束后变为现货再次上架。现货寄卖服务的服务时间最长6个月，寄卖时间截止后将联系作者将作品寄回作者处。 
</p>
<p>3. 发货开始后每月30日-次月2日由客服联系作者进行结算，结算范围为已确认收货的寄卖作品订单。第一次结算周期为从产品发货日至当月25日（如25日之前无确认收货订单则转入下月结算），之后结算周期为上月26日至本月25号的自然月直至结束寄卖服务，结算范围为已确认收货的寄卖作品订单。
</p>
      `,
      瑕疵品处理方案教程: `
根据产品瑕疵程度分级：轻度瑕疵（如撞角等），中度瑕疵（如封面有黑点，有硌的坑等），重度瑕疵（如折页，掉页，串页，重复页等），我方方案优先红包补偿，如果买家不同意则进行退换且退回运费由作者承担
`
    };
  },
  name: "Consignment",
  components: {}
};
</script>
<style scoped>
.consignment-product-tag {
  margin: 5px 5px 20px 5px;
}
</style>
